<template>
  <v-app>
    <AppPreloader />
    <router-view />
    <WhatsAppButton />
  </v-app>
</template>

<script>
import AppPreloader from './components/AppPreloader.vue'
import WhatsAppButton from './components/site/WhatsAppButton.vue'

export default {
  name: 'App',
  components: { AppPreloader, WhatsAppButton }
}
</script>
